
export enum StickyType {
  TOP,
  BOTTOM,
}
